import type { Money } from '@booking-core/domain/value_objects/money.js';
import type { PricingInput } from './pricing-strategy.js';
import { buildPricingStrategy, type StrategyParams } from './registry.js';

/**
 * Convenience fn: single-call quote without holding the strategy
 * instance. Handy for reservation price-calculator which just needs
 * "given this spec + this demand, how much?" once.
 */
export function quote(spec: StrategyParams, input: PricingInput): Money {
  return buildPricingStrategy(spec).quote(input);
}
